const purchaseBar = document.querySelector('.purchase-bar');
if (purchaseBar) {
  window.addEventListener(
    'scroll',
    () => {
      const threshold =
        purchaseBar.parentElement.offsetTop +
        purchaseBar.parentElement.offsetHeight;
      purchaseBar.classList.toggle('fixed', window.scrollY > threshold);
    },
    { passive: true },
  );

  purchaseBar.querySelector('.btn')?.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.product-section .buy_form')?.scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center',
    });
  });
}
